/*eslint-disable*/
import * as types from './../mutation-types'

const state = {
    puzzle: null
};


const mutations = {
    [types.SET_PUZZLE_GAME](state, data) {
        state.puzzle = data;
    },
};

export default {
    state,
    mutations
}